import { RedeemConfigState } from "src/features/finance/redeems/state/redeemConfigSlice";

export const getRedeemConfig = (state: RedeemConfigState) => state?.data;

export const getRedeemConfigLoading = (state: RedeemConfigState) =>
  state?.loading;

export const getRedeemConfigLoadingFailed = (state: RedeemConfigState) =>
  !!state.error;
